import "style/videoMetadataPage.css";
import { useEffect } from "react";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { VideosDeletedTable } from "features/videoUploads/tables/VideosDeletedTable";

export function VideoUploadsDeletedPage() {
	useEffect(() => {
		setScrollBehavior();
	}, []);

	return (
		<div className="videoMetadataList-container">
			<div className="listHeadline">Deleted videos:</div>
			<VideosDeletedTable />
		</div>
	);
}
